<template>
  <div class="hotspot" :style="{top: y, left: x}" @click="open = !open" :class="{open, rightAligned: relX > 0.5}">
    <div class="handle"></div>
    <div class="details">
      <div>
        <p>
          <strong>
            <slot name="title"></slot>
          </strong><br>
          <slot name="details"></slot>
        </p>
        <div class="close"><i class="material-icons">close</i></div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    props: ['x', 'y'],
    data() {
      return {
        open: false
      }
    },
    computed: {
      relX() {
        // Check if its relative
        if (this.x.slice(-1) === '%') {
          return this.x.slice(0, -1) / 100;
        }
        return 0;
      }
    }
  }
</script>


<style scoped lang="scss">
  $colorMain: #1976d2;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeout {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes pulse {
    from {
      box-shadow: 0 0 0 0px rgba($colorMain, 1);
    }
    to {
      box-shadow: 0 0 0 15px rgba($colorMain, 0);
    }
  }

  .hotspot {
    position: absolute;
    cursor: pointer;

    .details {
      display: block;
      position: absolute;
      left: -10px;
      top: -10px;
      border-radius: 20px;
      background: $colorMain;
      color: white;
      min-width: 240px;
      transition: box-shadow 200ms ease-in-out;
      box-shadow: 0 2px 6px rgba(#000, 0.4);
      padding-right: 60px;
      z-index: 10;
      max-height: 0;
      max-width: 0;
      transition: max-height 240ms ease, max-width 240ms ease, padding 240ms ease 240ms;
      overflow: hidden;

      > div {
        padding: 20px;
        padding-top: 0;
      }

      p {
        margin-bottom: 0;
      }

      .close {
        position: absolute;
        right: 20px;
        top: 20px;
        height: 25px;
        width: 25px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .material-icons {
          font-size: 20px;
        }

        &:hover {
          background: white;
          color: black;
        }
      }

      &:hover {
        box-shadow: 0 6px 12px rgba(#000, 0.4);
      }
    }

    .handle {
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background: $colorMain;
      position: absolute;
      top: -10px;
      left: -10px;
      border: 2px solid $colorMain;
      transition: opacity 200ms ease-in-out, box-shadow 200ms ease-in-out, transform 240ms ease-in-out;
      box-shadow: 0 2px 6px rgba(#000, 0.4);

      &:hover {
        box-shadow: 0 6px 12px rgba(#000, 0.4);
        transform: scale(1.5);
      }

      .hotspot-frame:hover & {
        opacity: 0.5;

        &:hover {
          opacity: 1;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        animation: fadein 0.5s;
        animation: pulse 1.5s infinite;
      }
    }

    &.rightAligned {
      .details {
        left: initial;
        right: -10px;
      }
    }

    &.open {
      .details {
        max-height: 1000px;
        max-width: 1000px;
        padding-top: 20px;
        transition: max-height 240ms ease, max-width 240ms ease, padding 240ms ease;
      }

      .handle {
        display: none;
      }
    }
  }
</style>
